import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Figure, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { saveDevice } from '../../pages/Device/DeviceSlice';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import defaultLogo from '../../assets/images/avatar.png';
import { resizeFile } from '../../common/uploadImage';
import { toast } from 'react-toastify';

const editDeviceSchema = yup.object().shape({
  name: yup.string().required('Name is a required field.'),
  label: yup.string(),
  description: yup.string(),
});
const ModalEditDevice = ({
  show,
  setShow,
  deviceId,
  deviceProfileId,
  customerId,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const dataDevice = useSelector((state) => state.device.device);
  const [validated, setValidated] = useState(false);

  const deviceInfo = dataDevice?.filter((item) => item.id.id === deviceId)[0];
  const token = localStorage.getItem('token');
  const [file, setFile] = useState();

  const {
    register,
    setValue,
    getValues,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editDeviceSchema),
  });

  useEffect(() => {
    if (show && !errors.name) {
      setValue('name', deviceInfo?.name);
      setValue('label', deviceInfo?.label);
      setValue('description', deviceInfo?.additionalInfo.description);
      setFile(deviceInfo?.attributes.avatar);
    }
    if (errors.name || errors.label || errors.description) {
      setValidated(true);
    } else setValidated(false);
  }, [errors, show, setValue, deviceInfo]);

  const handleClose = () => {
    clearErrors('name');
    clearErrors('label');
    clearErrors('description');
    setValidated(false);
    setShow(false);
  };

  const onSubmit = () => {
    const name = getValues('name');
    const label = getValues('label');
    const description = getValues('description');
    setValidated(true);
    dispatch(
      saveDevice({
        token,
        deviceId,
        deviceProfileId,
        customerId,
        name,
        label,
        description,
        file,
      })
    );
    setValidated(false);
    setShow(false);
  };

  const onChangeFile = async (file) => {
    try {
      const image = await resizeFile(file);
      setFile(image);
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <Modal onHide={handleClose} show={show} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t('edit-device')}</Modal.Title>
        {/* Chỉnh Sửa Container */}
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Row>
            <Col sm="4">
              <Figure.Image
                height={300}
                width="100%"
                style={{ borderRadius: '10px', objectFit: 'scale-down' }}
                src={file ? file : defaultLogo}
                alt="logo"
              />
              <Form.Group className="position-relative mb-3">
                <Form.Label>{t('avatar') /*Ảnh Đại Diện */}</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  name={t('choose-file')}
                  title={t('no-file')}
                  onChange={(e) => onChangeFile(e.target.files[0])}
                />
              </Form.Group>
            </Col>
            <Col row="8">
              <Form.Group as={Col} controlId="customerId">
                <Form.Label>{t('device-id')}:</Form.Label>
                {/* ID thiết bị */}
                <Form.Control required type="text" disabled value={deviceId} />
              </Form.Group>
              <Form.Group as={Col} controlId="deviceName">
                <Form.Label>
                  <span>
                    <i
                      class="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('name-device')}:
                </Form.Label>
                {/* tên thiết bị */}
                <Form.Control
                  required
                  type="text"
                  placeholder={t('name-device')}
                  {...register('name')}
                />
                {errors.name && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.name.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="deviceLabel">
                <Form.Label>{t('label-device')}:</Form.Label>
                {/* label */}
                <Form.Control
                  type="text"
                  placeholder={t('label-device')}
                  {...register('label')}
                />
                {errors.label && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.label.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="deviceContainer">
                <Form.Label>{t('container') /* Container */}:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('container')}
                  {...register('description')}
                />
                {errors.description && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.description.message}</p>
                  </Alert>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" type="submit">
            {t('update')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalEditDevice;
